(function () {
  'use strict';
  const root = document.getElementById('ns16');
  if (!root) return;
  const money = (n, digits = 0) => new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: digits, minimumFractionDigits: digits }).format(n);
  const cost = Number(root.dataset.price) / 100;
  function model(night, day, utilisation) {
    const daily = Number(root.dataset.usable || 15.27) * utilisation * (.938 * day - night / .939);
    let cumulative = 0;
    let payback = null;
    const years = Array.from({ length: 15 }, (_, index) => {
      const year = index + 1;
      const health = Math.max(.7, 1 - .3 * 365 * utilisation * (year - .5) / 8000);
      const annual = daily * 365 * health;
      const previous = cumulative;
      cumulative += annual;
      if (payback === null && annual > 0 && cumulative >= cost) payback = year - 1 + (cost - previous) / annual;
      return { year, health, annual, cumulative, net: cumulative - cost };
    });
    return { daily, payback, years };
  }
  const base = model(.085, .35, 1);
  function chart(values, maximum, label, unit, reference) {
    const width = 520, height = 250, left = 60, top = 15, bottom = 205, right = 505;
    const x = (i) => left + i * (right - left) / (values.length - 1);
    const y = (v) => bottom - v / maximum * (bottom - top);
    let svg = `<svg viewBox="0 0 ${width} ${height}" role="img" aria-label="${label}"><title>${label}</title>`;
    [0, .5, 1].forEach((fraction) => {
      const value = maximum * fraction;
      svg += `<line x1="${left}" y1="${y(value)}" x2="${right}" y2="${y(value)}" stroke="#dce3ec"/><text x="${left - 8}" y="${y(value) + 4}" font-size="12" fill="#53627a" text-anchor="end">${money(value)}</text>`;
    });
    const points = values.map((v, i) => `${x(i)},${y(v)}`).join(' ');
    svg += `<polyline points="${points}" stroke="#1b2e51" stroke-width="3" fill="none"/>`;
    if (reference) {
      svg += `<line x1="${left}" y1="${y(reference)}" x2="${right}" y2="${y(reference)}" stroke="#b96b05" stroke-width="2" stroke-dasharray="5 4"/><text x="${right}" y="${y(reference) - 8}" font-size="12" fill="#805000" text-anchor="end">${money(cost)} equipment</text>`;
      const px = x(base.payback);
      svg += `<circle cx="${px}" cy="${y(reference)}" r="5" fill="#b96b05"/><text x="${px + 7}" y="${y(reference) + 19}" font-size="12" fill="#805000">Payback ~${base.payback.toFixed(1)} years</text>`;
    }
    [0, Math.floor((values.length - 1) / 2), values.length - 1].forEach((i) => {
      svg += `<text x="${x(i)}" y="228" font-size="12" text-anchor="middle" fill="#53627a">Year ${i + unit}</text>`;
    });
    svg += '</svg>';
    return svg;
  }
  root.querySelector('#ns-annual-chart').innerHTML = chart(base.years.map(y => y.annual), Math.ceil(base.years[0].annual / 500) * 500, 'Illustrative annual savings for the selected package. See the data table below.', 1, null);
  root.querySelector('#ns-cumulative-chart').innerHTML = chart([0, ...base.years.map(y => y.cumulative)], Math.ceil(base.years[14].cumulative / 5000) * 5000, 'Illustrative cumulative savings for the selected package. See the data table below.', 0, cost);
  root.querySelector('#ns-base-payback').textContent = `Approx. ${base.payback.toFixed(1)} years`;
  root.querySelector('#ns-base-year1').textContent = money(base.years[0].annual);
  root.querySelector('#ns-base-net10').textContent = money(base.years[9].net);
  root.querySelector('#ns-base-net15').textContent = money(base.years[14].net);
  root.querySelector('#ns-model-table').innerHTML = base.years.filter(y => [1,2,3,5,10,15].includes(y.year)).map(y => `<tr><th scope="row">${y.year}</th><td>${(y.health*100).toFixed(1)}%</td><td>${money(y.annual)}</td><td>${money(y.cumulative)}</td><td>${money(y.net)}</td></tr>`).join('');
  const choices = JSON.parse(root.querySelector('#ns-choice-data').textContent);
  root.querySelector('#ns-battery-brand').addEventListener('change', event => {
    const choice = choices.find(v => v.brand === event.target.value && v.count === Number(root.dataset.batteryCount));
    if (!choice) return;
    const url = new URL(window.location.href); url.searchParams.set('variant', choice.id); window.location.assign(url.href);
  });
  root.querySelector('#ns-capacity').addEventListener('change', event => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.href);
  });
  // Keep pack, graphs, price and usable capacity on the same selected variant.
  root.querySelectorAll('[data-ns-savings-choice]').forEach(select => {
    select.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      ['ns-night', 'ns-day', 'ns-use'].forEach(id => {
        const input = root.querySelector('#' + id);
        if (input.value !== '' && input.validity.valid) url.searchParams.set(id, input.value);
        else url.searchParams.delete(id);
      });
      url.hash = select.dataset.target;
      window.location.assign(url.href);
    });
  });
  const savingsParams = new URL(window.location.href).searchParams;
  ['ns-night', 'ns-day', 'ns-use'].forEach(id => {
    if (!savingsParams.has(id)) return;
    const input = root.querySelector('#' + id), previous = input.value;
    const value = savingsParams.get(id);
    if (value.trim() === '' || !Number.isFinite(Number(value))) return;
    input.value = value;
    if (!input.validity.valid) input.value = previous;
  });
  function update() {
    const nightInput = root.querySelector('#ns-night');
    const dayInput = root.querySelector('#ns-day');
    const utilisation = Number(root.querySelector('#ns-use').value) / 100;
    root.querySelector('#ns-use-value').textContent = `${Math.round(utilisation * 100)}%`;
    const target = root.querySelector('#ns-calc-results');
    if (!nightInput.validity.valid || !dayInput.validity.valid || nightInput.value === '' || dayInput.value === '') {
      target.textContent = 'Please enter valid rates between €0 and €10 per kWh.';
      return;
    }
    const result = model(Number(nightInput.value), Number(dayInput.value), utilisation);
    const payback = result.daily <= 0 ? 'No payback' : result.payback === null ? 'Over 15 years' : `${result.payback.toFixed(1)} years`;
    const items = [[money(result.daily, 2), 'Estimated saving per day when new'], [money(result.years[0].annual), 'Estimated year 1 saving'], [payback, 'Estimated equipment payback'], [money(result.years[9].net), 'Estimated 10-year net benefit'], [money(result.years[14].net), 'Estimated 15-year net benefit']];
    target.replaceChildren(...items.map(([value, label]) => {
      const card = document.createElement('div'), strong = document.createElement('strong'), span = document.createElement('span');
      strong.textContent = value; span.textContent = label; card.append(strong, span); return card;
    }));
  }
  ['ns-night', 'ns-day', 'ns-use'].forEach(id => root.querySelector(`#${id}`).addEventListener('input', update));
  update();
  root.querySelectorAll('.ns-thumb').forEach(button => button.addEventListener('click', () => {
    const image = root.querySelector('#ns-main-image');
    image.src = button.dataset.image; image.alt = button.dataset.alt;
    root.querySelector('#ns-main-link').href = button.dataset.full;
    root.querySelectorAll('.ns-thumb').forEach(item => {
      const selected = item === button; item.classList.toggle('is-selected', selected); item.setAttribute('aria-pressed', String(selected));
    });
  }));
})();
